const RECEIPT_PADDING = 26;
const RECEIPT_PADDING_DESKTOP = 64;

export const getPaddingHorizontal = (isDesktop: boolean) => {
  return isDesktop ? RECEIPT_PADDING_DESKTOP : RECEIPT_PADDING;
};
